import ascSort from 'utils/ascSort'

const optionFilterByTypeBuilder = () => {
  const filterOptionsByProductType = {}

  const add = (type, filter, value) => {
    if (type) {
      if (!filterOptionsByProductType[type]) {
        filterOptionsByProductType[type] = {
          period: new Set<number>(),
          coinsurance: new Set<string>(),
          moop: new Set<string>(),
          deductibleOptions: new Set<number>(),
          coverageOptions: new Set<number>()
        }
      }
      filterOptionsByProductType[type][filter].add(value)
    }
  }

  const getFormatted = () => {
    const optionFilters = {}

    Object.keys(filterOptionsByProductType).forEach(type => {
      optionFilters[type] = {
        period: {
          type: 'one',
          values: [...filterOptionsByProductType[type].period]
        },
        coverage: {
          type: 'one',
          values: [...filterOptionsByProductType[type].coverageOptions].sort(ascSort)
        },
        deductible: {
          type: 'one',
          values: [...filterOptionsByProductType[type].deductibleOptions].sort(ascSort)
        },
        coinsurance: {
          type: 'one',
          values: [...filterOptionsByProductType[type].coinsurance].sort()
        },
        moop: {
          type: 'one',
          values: [...filterOptionsByProductType[type].moop].sort((a, b) => +a - +b)
        }
      }
    })
    return optionFilters
  }

  return { add, getFormatted }
}

export default optionFilterByTypeBuilder
